import { Box} from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';

export interface BasicDatePickerProps {
    width?: number;
    label?: string;
    value?: string;
    onChange?: (date: string | null) => void;
}




export function BasicDatePicker(props: BasicDatePickerProps) {

    function updateDatePickerValue(date: Dayjs | null) {

        if (!props.onChange) {
            console.warn("onChange function is not provided in BasicDatePickerProps");
            return;
        }
    
        if (date) { 
            // Convert the date to a string in the format 'YYYY-MM-DDT12:00:00[Z]'
            // This ensures the time is set to noon UTC, which is a common practice for date pickers
            // to avoid timezone issues.
            const strDate = date.format('YYYY-MM-DDT12:00:00[Z]'); // Format the date to 'YYYY-MM-DD'
            props.onChange(strDate);

        } else {
            props.onChange(null);
        }
    }

    return (
       <Box sx={{ width: props.width ?? 250 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label={props.label || "Select Date"}
                    value={props.value ? dayjs(props.value) : null}
                    onChange={updateDatePickerValue}
                    slotProps={{ textField: { fullWidth: true } }}
                />
            </LocalizationProvider>
       </Box>
    );

}